import { useSingleSelectContext } from '../../contexts/context.mjs';

function SingleSelectValue({ children }) {
  const { value } = useSingleSelectContext("Value");
  return children?.(value);
}

export { SingleSelectValue as SelectValue };
//# sourceMappingURL=Value.mjs.map
